/**
 * @module reporting
 *
 * The reporting state consists of 3 main sections: filters, results, and entities.
 * Filters represent the user's intention of what data they wish to see. Results
 * represent the results of those selections. Entities comprise a set of axiomatic
 * datums which are used as building blocks to create reports.
 */
import { combineReducers } from '@reduxjs/toolkit';
import filters from './filters';
import results from './results';
import * as entities from './entities';
import { benchmarks } from './benchmarks';

const reporting = combineReducers({
  filters,
  results,
  entities: combineReducers(entities),
  benchmarks,
});

export default reporting;
